import React, { useState } from "react";
import { Avatar, Button } from "@material-tailwind/react";
import { PlayIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { useReduxStore } from "../hooks/useReduxStore";
import BasicInfoComponent from "./BasicInfoComponent";
import ChangePasswordComponent from "./ChangePasswordComponent";
export default function ProfileForm() {
  const { getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { avatar } = userData || {};
  const [ch_password, setChPassword] = useState(false);
  return (
    <section className="w-full rounded-xl bg-zinc-950 border border-zinc-900 p-6 py-10 md:p-12 xl:p-16 shadow-2xl">
      <div className="mx-auto w-full">
        <div className="grid grid-cols-1">
          <div className="w-full">
            <div className="space-y-8">
              <div className="flex flex-col md:flex-row justify-between items-center mb-8">
                <Avatar
                  src={
                    avatar ||
                    "https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                  }
                  alt="avatar"
                  variant="square"
                  withBorder={true}
                  color="orange"
                  className="p-0.5 w-[10rem] h-[10rem] border-2 border-secondary rounded-lg"
                />
              </div>
              {!ch_password ? (
                <BasicInfoComponent dark={true} />
              ) : (
                <ChangePasswordComponent dark={true} />
              )}
              <div className="mt-8 pt-4 border-t border-zinc-900">
                <Button
                  onClick={() => setChPassword(!ch_password)}
                  color="orange"
                  variant="text"
                  className="flex items-center px-4 py-2 text-sm font-semibold capitalize text-secondary hover:bg-secondary/10 transition-colors duration-200"
                >
                  {ch_password ? "Don't Change Password" : "Change Password"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
